import { useState } from 'react';
import { SaveAsTemplateDialogProps } from './SaveAsTemplateDialogTypes';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Typography,
} from '@mui/material';

function SaveAsTemplateDialog<T>({
  open,
  onClose,
  onSave,
  data,
  templateTypeLabel,
  onSuccess,
}: SaveAsTemplateDialogProps<T>) {
  const [templateName, setTemplateName] = useState('');
  const [templateDescription, setTemplateDescription] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [isSuccess, setIsSuccess] = useState(false);

  const handleSave = async () => {
    setIsLoading(true);
    setError(null);
    try {
      await onSave({
        name: templateName,
        data,
      });
      setIsSuccess(true);
      setTemplateName('');
      setTemplateDescription('');
      onClose();
      onSuccess?.();
    } catch (err: any) {
      setError('Wystąpił błąd przy zapisie szablonu.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>{`Zapisz ${templateTypeLabel} jako szablon`}</DialogTitle>
      <DialogContent>
        <TextField
          label="Nazwa szablonu"
          value={templateName}
          onChange={(e) => setTemplateName(e.target.value)}
          fullWidth
          sx={{ mb: 2, mt: 1 }}
          autoFocus
          required
        />
        <TextField
          label="Opis (opcjonalnie)"
          value={templateDescription}
          onChange={(e) => setTemplateDescription(e.target.value)}
          fullWidth
          multiline
          minRows={2}
        />
        {error && (
          <Typography color="error" variant="body2" sx={{ mt: 2 }}>
            {error}
          </Typography>
        )}
        {isSuccess && (
          <Typography color="success.main" variant="body2" sx={{ mt: 2 }}>
            Szablon zapisany pomyślnie!
          </Typography>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={isLoading}>
          Anuluj
        </Button>
        <Button onClick={handleSave} variant="contained" disabled={!templateName || isLoading}>
          Zapisz
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default SaveAsTemplateDialog;
